interface IUserWalletBalance {
  blocked: number;
  dividend_paid: number;
  dividend_earned: number;
  available_balance: number;
  total_balance: number;
}

class UserWalletBalance implements IUserWalletBalance {
  blocked: number;
  dividend_paid: number;
  dividend_earned: number;
  available_balance: number;
  total_balance: number;

  constructor(data: Partial<IUserWalletBalance>) {
    this.blocked = data?.blocked ?? 0;
    this.dividend_paid = data?.dividend_paid ?? 0;
    this.dividend_earned = data?.dividend_earned ?? 0;
    this.available_balance = data?.available_balance ?? 0;
    this.total_balance = data?.total_balance ?? 0;
  }

  static fromJson(data: any) {
    return new UserWalletBalance(data);
  }

  toJson(): IUserWalletBalance {
    return {
      blocked: this.blocked,
      dividend_paid: this.dividend_paid,
      dividend_earned: this.dividend_earned,
      available_balance: this.available_balance,
      total_balance: this.total_balance,
    };
  }
}

export default UserWalletBalance;
